export default __webpack_public_path__ + "static/media/column-end-placeholder2.618ac06f.png";